export default "__VITE_ASSET__kE_wI$Hf__"